export const getEditWebsiteViewStyle = () => ({
  container: {
    fontSize: '14px',
    marginLeft: 26,
    marginBottom: 12,
  },
  description: {
    marginBottom: 24,
  },
  descriptionExpanded: {
    marginLeft: 26,
  },
});

export const optionSelectorStyle = {
  flexContainer: [
    {
      selectors: {
        '.ms-ChoiceField': {
          backgroundColor: '#F3F2F1',
          width: 503,
          minHeight: 110,
          marginBottom: 24,
        },
        '.ms-ChoiceField-wrapper': {
          width: '-webkit-fill-available',
          height: '-webkit-fill-available',
          marginLeft: 20,
        },
        '.ms-ChoiceField-field': {
          float: 'right',
          marginTop: 5,
        },
        '.ms-Icon': {
          'vertical-align': 'text-top',
        },
        '.text': {
          marginTop: 20,
        },
        '.title-container': {
          fontWeight: 'bold',
        },
        '.title-icon': {
          color: '#000000',
        },
        '.title-text': {
          display: 'inline-block',
          marginLeft: 6,
        },
      },
    },
  ],
};

export const optionSelectorClasses = () => ({
  title: {
    fontWeight: '600',
    display: 'inline-block',
    lineHeight: '20px',
    margin: '8px 0px',
    fontSize: '14px',
  },
  selectableButtonLarge: {
    height: '174px',
  },
  cardHeaderLarge: {
    height: undefined,
  },
});
